/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TreatmentPlanStatus2 {
    NEW = 'new',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}
